<template>
  <div align="center">
    <page-header></page-header>
    <div class="navbar_website_map">
      <img src="../../assets/img/jt.jpg" width="9" height="9" />
      {{ $t("currlocation") }}:
      <router-link :to="{ name: 'login' }">{{ $t("index") }}</router-link>
     <img src="../../assets/img/jt.gif" /><a href="javascript:history.go(-2)">{{ $t("inquiry") }} </a>
      <img src="../../assets/img/jt.gif" /><a href="javascript:history.go(-1)">
        <span v-if="AwbBlType=='S'">  {{ $t("sea") }} </span> 
        <span v-if="AwbBlType=='A'"> {{ $t("air") }}</span> 
         </a>
      <img src="../../assets/img/jt.gif" />{{ $t("normal_info") }}

       
    </div>
    <div align="center">
      <table width="98%" cellpadding="0" cellspacing="0">
        <tr>
          <td width="25%" align="left" style="white-space:nowrap"><b>{{ $t("normal_billtype") }}</b> &nbsp; {{tgAwbBlDtails.billType}}</td>
          <td width="25%" align="left" style="white-space:nowrap"><b>
              {{ $t("anonymou_house_no") }} : <span style="font-size:17px"> {{tgAwbBlDtails.houseNo}}</span>
            </b></td>
          <td width="25%" align="left" style="white-space:nowrap"><b>
              {{ $t("normal_mawb") }}: <span style="font-size:17px"> {{tgAwbBlDtails.masterNo}}</span>
            </b></td>
          <td width="25%" align="left"> &nbsp; </td>
        </tr>
      </table>
      <table width="98%" cellpadding="1" cellspacing="1" class="main_talbe">
        <tr class="tr3">
          <td class="tr2 table_info_th" width="15%" >
            <P STYLE="COLOR:WHITE">{{ $t("normal_shprename") }}:</P>
          </td>
          <td valign="middle" align="left" style="border-top: solid 1px #e6e6e6;" >&nbsp;{{tgAwbBlDtails.shprEname}}</td>
        </tr>
        <tr class="tr3">
          <td class="tr2 table_info_th">
            <P STYLE="COLOR:WHITE"> {{ $t("normal_shpradd") }}:</P>
          </td>
          <td valign="middle" align="left" >&nbsp;{{tgAwbBlDtails.shprEaddr}}</td>
        </tr>
      </table>
      <br />
      <table width="98%" cellpadding="1" cellspacing="1" class="main_talbe">
        <tr class="tr3">
          <td class="tr4 table_info_th">
            <P STYLE="COLOR:WHITE"> {{ $t("normal_cneecode") }}:</P>
          </td>
          <td valign="middle" align="left" style="border-top: solid 1px #e6e6e6;">&nbsp; {{tgAwbBlDtails.cneeCode}} </td>
        </tr>
        <tr class="tr3">
          <td class="tr4 table_info_th">
            <P STYLE="COLOR:WHITE"> {{ $t("normal_consignee") }}:</P>
          </td>
          <td valign="middle" align="left">&nbsp; {{tgAwbBlDtails.cneeEname}} </td>
        </tr>
        <tr class="tr3">
          <td class="tr4 table_info_th">
            <P STYLE="COLOR:WHITE">{{ $t("normal_cneeadd") }}:</P>
          </td>
          <td valign="middle" align="left">&nbsp;{{tgAwbBlDtails.cneeEaddr}} </td>
        </tr>
      </table>
      <br>
      <table width="98%" cellpadding="0" cellspacing="0">
        <tr>
          <td width="25%" align="left">
            <b>
               {{ $t("normal_orgncode") }}: &nbsp; {{tgAwbBlDtails.orgnCode}} &nbsp;
              <span style="font-size:17px"> {{tgAwbBlDtails.orgnDescp}}</span>
            </b>
          </td>
          <td width="25%" align="left">
              <b>
              {{ $t("normal_dest") }}:&nbsp; {{tgAwbBlDtails.destCode}} &nbsp; <span style="font-size:17px"> {{tgAwbBlDtails.destDescp}}</span>
            </b> </td>
          <td width="50%"></td>
        </tr> 
      </table>
       <table width="98%" cellpadding="1" cellspacing="1" class="main_talbe">
      <!--DWLayoutTable-->
    <tbody>
	  <tr class="tr3">
      <td width="15%" height="18" valign="middle" class="tr2 table_info_th">{{ $t("normal_fligde") }} :</td>
      <td width=21% valign="middle" class="table_info_th"><b>{{ $t("normal_to1_code") }}</b></td>
      <td width=20% valign="middle" class="table_info_th"><b>{{ $t("normal_flino") }}</b></td>
      <td width=22% valign="middle" class="table_info_th"><b>{{ $t("normal_etd") }} </b></td>
      <td width=22% valign="middle" class="table_info_th"><b>{{ $t("normal_eta") }} </b></td>
      </tr>
	  <tr class="tr3">
      <td class="tr2">{{ $t("normal_first") }}</td>
      <td>{{tgAwbBlDtails.to1Code}}</td>
      <td>{{tgAwbBlDtails.fltNo1}}</td>
      <td>{{tgAwbBlDtails.etdDate1}}</td>
      <td>{{tgAwbBlDtails.etaDate1}}</td>      
      </tr>
    </tbody>
       </table> 
       <br>
  <table width="98%" cellpadding="1" cellspacing="1" class="main_talbe">
      <!--DWLayoutTable-->
    <tbody>
	  <tr class="tr3">
      <td width="15%" height="18" valign="middle" class="tr2 table_info_th" > {{ $t("normal_pkg") }}:</td>
      <td width="15%" height="18" valign="middle" class="tr2 table_info_th" > {{ $t("gw") }}:</td>
      <td width="15%" valign="middle" class="tr2 table_info_th" > {{ $t("cw") }}:</td>
      <td width="15%" height="18" valign="middle" class="tr2 table_info_th">TERMS:</td>
      <td valign="middle" class="tr2 table_info_th">{{ $t("freight") }}</td>
      <td valign="middle" class="tr2 table_info_th" >{{ $t("other") }}</td> 
      </tr>
	  <tr class="tr3">
      <td width=18% valign="middle">&nbsp;<b> {{tgAwbBlDtails.qty}}</b></td>
      <td width=18% valign="middle">&nbsp;<b> {{tgAwbBlDtails.gw}}</b></td>
      <td width=18% valign="middle">&nbsp;<b> {{tgAwbBlDtails.cw}}</b></td>
      <td valign="middle">&nbsp;<b> {{tgAwbBlDtails.incoTerms}}</b></td>
      <td valign="middle">&nbsp;<b> {{tgAwbBlDtails.frtTerm}}</b></td>
      <td valign="middle">&nbsp;<b> {{tgAwbBlDtails.othTerm}}</b></td>
      </tr>
    </tbody>
  </table> 

   <br/>
  <table width="98%" cellpadding="1" cellspacing="1" class="main_talbe">
      <!--DWLayoutTable-->
    <tbody>
      <tr class="tr3">
      <td height="18" valign="middle" class="tr2 table_info_th"> {{ $t("normal_marks") }}:</td>
      <td colspan="6" anlign="middle" align="left">&nbsp;{{tgAwbBlDtails.marks}}</td>
      </tr>
      <tr class="tr3">
      <td class="tr2 table_info_th"  > {{ $t("normal_descp") }}:</td>
      <td colspan="6" valign="middle" align="left">&nbsp;{{tgAwbBlDtails.goodsDescp}}</td>
      </tr>
    </tbody>
       <tbody>
		      <tr class="tr3"> 
		      <td  anlign="middle" align="left">&nbsp;INV NO.</td>
		      <td  anlign="middle" align="left">&nbsp;PO NO.</td>
		      </tr>
            
       <!-- <template v-for="(item,index) in tgTxInvpoList" :key="index"> -->
	 	  <!-- <bean:define id="tp" type="TG_INV_PO" name="obj" /> -->
		      <tr class="tr3" v-for="(item,index) in tgTxInvpoList" :key="index"> 
		      <td anlign="middle" align="left">&nbsp;{{item.invNo}}</td>
		      <td anlign="middle" align="left">&nbsp;{{item.poNo}}</td>
		      </tr>
     <!-- </template> -->
    </tbody>
      <!-- {{tgTxInvpoList}}
    {{kk}} -->
  </table> 
    </div>
    <page-footer></page-footer>
  </div>
</template>
<script>
import PageFooter from "@/components/infrastructure/layout/page-footer.vue";
import PageHeader from "@/components/infrastructure/layout/page-header.vue";
import TableNoRecord from "@/components/infrastructure/table/table-no-record.vue";
import { GetDeatils } from "@/api/branchBillOflading.js";
export default {
  components: {
    PageHeader,
    PageFooter,
    TableNoRecord,
  },
  data() {
    return {
      HouseNo: "",
      tgTxInvpoList: [],
    tgAwbBlDtails: {
    billType:'',

    },
    Search:{

    },
    AwbBlType:''
    // kk:"2"
    }
  },
  async mounted() {
     var model = JSON.parse(this.$route.query.info);
    this.Search=model.item;
    this.AwbBlType=this.$route.query.AwbBlType;
    this.HouseNo = this.Search.house_No;
    //  console.log(this.Search);
    //     console.log(this.AwbBlType);
      var self = this;
    await GetDeatils({ HouseNo: this.HouseNo }).then((res) => {
      if (res.code == 200) {
        self.tgAwbBlDtails = res.data.tgAwbBlDtails==null?{}:res.data.tgAwbBlDtails;
        self.tgTxInvpoList = res.data.tgTxInvpo;
        // self.kk=1;
        // console.log(res.data.tgTxInvpo);
        //  console.log(this.tgTxInvpoList)
      }
    });
  },
};
</script>
<style lang="less">
</style>